/**
 * Action types for firmware Management functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_FIRMWARE_MANAGEMENT = 'GET_FIRMWARE_MANAGEMENT';
export const GET_FIRMWARE_MANAGEMENT_SUCCESS = 'GET_FIRMWARE_MANAGEMENT_SUCCESS';
export const GET_FIRMWARE_MANAGEMENT_FAIL = 'GET_FIRMWARE_MANAGEMENT_FAIL';
export const DELETE_FIRMWARE_MANAGEMENT = 'DELETE__FIRMWARE_MANAGEMENT';
export const DELETE_FIRMWARE_MANAGEMENT_SUCCESS = 'DELETE_FIRMWARE_MANAGEMENT_SUCCESS';
export const DELETE_FIRMWARE_MANAGEMENT_FAIL = 'DELETE_FIRMWARE_MANAGEMENT_FAIL';
export const GET_DEVICE_FILTER_LIST = "GET_DEVICE_FILTER_LIST";
export const DEVICE_FILTER_LIST_GET_SUCCESS = "DEVICE_FILTER_LIST_GET_SUCCESS";
export const DEVICE_FILTER_LIST_GET_FAIL = "DEVICE_FILTER_LIST_GET_FAIL";
export const ADD_FIRMWARE_MANAGEMENT = 'ADD_FIRMWARE_MANAGEMENT';
export const ADD_FIRMWARE_MANAGEMENT_COMPLETE = 'ADD_FIRMWARE_MANAGEMENT_COMPLETE';
export const ADD_FIRMWARE_MANAGEMENT_SCHEDULE = 'ADD_FIRMWARE_MANAGEMENT_SCHEDULE';
export const ADD_FIRMWARE_MANAGEMENT_SCHEDULE_COMPLETE = 'ADD_FIRMWARE_MANAGEMENT_SCHEDULE_COMPLETE';
export const EDIT_FIRMWARE_MANAGEMENT_SCHEDULE = 'EDIT_FIRMWARE_MANAGEMENT_SCHEDULE';
export const EDIT_FIRMWARE_MANAGEMENT_SCHEDULE_COMPLETE = 'EDIT_FIRMWARE_MANAGEMENT_SCHEDULE_COMPLETE';
export const GET_DEVICE_LIST_ALL = "GET_DEVICE_LIST_ALL";
export const DEVICE_LIST_ALL_GET_SUCCESS = "DEVICE_LIST_ALL_GET_SUCCESS";
export const DEVICE_LIST_ALL_GET_FAIL = "DEVICE_LIST_ALL_GET_FAIL";